import * as React from "react";
import * as R from "ramda";
import {Form} from "react-final-form";
import {Col, Row} from "react-bootstrap";
import TipoIdentificacion from "../../general/componentes/TipoIdentificacion";
import NumericInput from "../../general/componentes/NumericInput";
import TipoCliente from "../../general/componentes/TipoCliente";
import {connect} from "react-redux";
import TablaDocumentos from "./TablaDocumentos";
import {consultarDocumentosComercial} from "../modulos/documentosActions";
import DatePickerSura from "../../general/componentes/DatePicker";
import {Documento, FiltroDocumento} from "../modelo/Documento";
import InformacionBasicaDocumento from "./InformacionBasicaDocumento";
import {REQUEST} from "../../../config/ajax-wrapper";
import {Mensaje} from "../../general/componentes/Mensaje";
import {DotLoader} from "react-spinners";
import { TIPO_GESTION } from "../modelo/TipoGestion";


class DocumentosComercial extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        const { documentosComercial, estadoComercial, paginas, tamanoPagina, paginaActual } = this.props;
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({handleSubmit, invalid, errors, form, submitting, pristine, values}) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Solicitud Canal Comercial</h1> 
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar documentos</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className="form-group">
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento</label>
                                                <TipoIdentificacion name="tipoDocumento"/>
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento</label>
                                                <NumericInput name="documento" placeholder="Ingrese un documento"/>
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Inicio Radicación</label>
                                                <DatePickerSura name={"fechaInicio"}/>
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Fin Radicación</label>
                                                <DatePickerSura name={"fechaFin"}/>
                                            </Col>
                                        </Row>
                                        <Row className="form-group">
                                            <Col sm={3}>
                                                <label>Tipo Cliente</label>
                                                <TipoCliente name="tipoCliente" excluir={["DE","OI","VI"]}/>
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="contrato">Contrato</label>
                                                <NumericInput name="contrato" placeholder="Ingrese un contrato"/>
                                            </Col>
                                        </Row>
                                        <Row className="form-group">
                                            <Col smOffset={7} sm={1}>
                                                <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={1}>
                                                <button type="submit" className="btns btns-primary"
                                                        disabled={submitting || invalid}>
                                                    Consultar
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderDocumentos(documentosComercial, estadoComercial, paginas, tamanoPagina, paginaActual)}
                </Row>
            </div>
        );
    }

    filtros(): FiltroDocumento {
        return {
            dni: this.state.dni,
            tipoCliente: this.state.tipoCliente,
            tipoTramite: this.state.tipoTramite,
            fechaInicio: this.state.fechaInicio,
            fechaFin:    this.state.fechaFin,
            canalComercial: true,
            poliza: this.state.contrato
        };   
        
    }

    consultaPaginada = (filtroDocumento: FiltroDocumento) => {
        this.props.dispatch(consultarDocumentosComercial(filtroDocumento));
    };

    renderDocumentos(documentosComercial: Array<Documento>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error consultando los documentos"}/>;
            case REQUEST.PENDING:
                return <DotLoader size={25}/>;
            case REQUEST.SUCCESS:
                const mensajeUsuario = !this.props.mensajeUsuario ? "" : (
                    <Mensaje type={this.props.mensajeUsuario.type}
                             mensaje={this.props.mensajeUsuario.text}/>
                );
                if (!documentosComercial || documentosComercial.length === 0 ) {
                    return (
                        <span>
                            {mensajeUsuario}
                            <Mensaje type={"danger"} mensaje={"No hemos encontrado documentos :("}/>
                        </span>
                    );
                } else {
                    return (
                        <span>
                        {mensajeUsuario}
                            {documentosComercial.length === 1 ? <InformacionBasicaDocumento documento={documentosComercial[0]} canalComercial/> :
                                <TablaDocumentos 
                                    estado={this.props.estadoReintento}
                                    documentos={documentosComercial} 
                                    filtroDocumento={this.filtros()}
                                    consultaPaginada={this.consultaPaginada}
                                    paginas={paginas} 
                                    tamanoPagina={tamanoPagina}
                                    paginaActual={paginaActual}
                                    tipoGestion={TIPO_GESTION.DOCUMENTOS_AFILIACION_COMERCIAL}
                                />}
                        </span>
                    );
                }
            default:
                return false;
        }
    }

    validate = values => {
        const errors = {documento: undefined, tipoDocumento: undefined, fechaInicio: undefined, fechaFin: undefined};

        if (values.tipoDocumento && !values.documento) {
            errors.documento = "Por favor ingrese un documento";
        }

        if (!values.tipoDocumento && values.documento) {
            errors.tipoDocumento = "Por favor selecciona un tipo de documento";
        }

        if (values.fechaInicio && !values.fechaFin) {
            errors.fechaFin = "Por favor selecciona una fecha de fin";
        }

        if (!values.fechaInicio && values.fechaFin) {
            errors.fechaInicio = "Por favor selecciona una fecha de inicio";
        }

        if (values.fechaInicio && values.fechaFin &&
            (values.fechaInicio.isAfter(values.fechaFin))) {
            errors.fechaFin = "La fecha fin no puede ser anterior a la fecha de inicio";
        }

        return errors;
    };

    onSubmit = values => {
        const dni = values.tipoDocumento && values.documento ? (values.tipoDocumento + values.documento) : undefined;
        const tipoCliente = values.tipoCliente ? values.tipoCliente.valueOf() : "";
        const tipoTramite = "VIRTUAL";
        
        const fechaInicio = values.fechaInicio ? values.fechaInicio.valueOf() : "";
        const fechaFin = values.fechaFin ? values.fechaFin.valueOf() : "";

        const canalComercial = true;
        const contrato = values.contrato ? values.contrato.valueOf() : "";

        const filtroDocumento: FiltroDocumento = {
            dni: dni, 
            tipoCliente: tipoCliente, 
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0,
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            tipoTramite: tipoTramite,
            canalComercial: canalComercial,
            poliza: contrato
        };

        this.setState(
            {
                dni: dni, 
                tipoCliente: tipoCliente, 
                estado: values.estado, 
                tipoTramite: tipoTramite,
                fechaInicio: fechaInicio,
                fechaFin: fechaFin, 
                canalComercial: canalComercial,
                poliza: contrato
            }
        );

        this.props.dispatch(consultarDocumentosComercial(filtroDocumento));
    }

}


export default connect((store: any) => {
    return {
        documentosComercial: R.pathOr([], ["documentos", "documentosComercial"])(store),
        estadoComercial: R.pathOr(REQUEST.NONE, ["documentos", "estadoComercial"])(store),
        mensajeUsuario: R.pathOr(false, ["documentos", "mensajeUsuario"])(store),
        tamanoPagina: R.pathOr([], ["documentos", "tamanoPagina"])(store),
        paginaActual: R.pathOr([], ["documentos", "paginaActual"])(store),
        paginas: R.pathOr(1, ["documentos", "paginas"])(store)
    };
})(DocumentosComercial);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/DocumentosComercial.tsx